import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'

interface UseMaintenanceDirectiveDiagnosticEntryRegressProps {
  directiveEntryId: string | undefined
  options?: Partial<Omit<UseMutationOptions<unknown, ErrorResponse>, 'mutationKey' | 'mutationFn'>>
}

export const useMaintenanceDirectiveDiagnosticEntryRegress = ({
  directiveEntryId,
  options,
}: UseMaintenanceDirectiveDiagnosticEntryRegressProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['maintenanceDirectiveDiagnosticEntryRegress'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/directive/diagnostic_entries/${directiveEntryId}/regress`)
    },
    ...options,
  })
}
